'use client'

export function SupportResistanceSection() {
  return (
    <section
      className="overflow-hidden bg-black py-16 md:py-32"
      style={{ fontFamily: 'var(--font-ppmori, PPMori), sans-serif' }}
    >
      {/* Text */}
      <div className="mx-auto max-w-5xl px-6">
        <div className="max-w-xl space-y-4">
          <h2 className="text-4xl font-medium text-white lg:text-5xl">
            Identify levels before price gets there.
          </h2>
          <p className="text-lg text-white/50">
            The Support &amp; Resistance prompt maps the strongest price zones instantly — showing you exactly where the market has memory, and where it&apos;s most likely to react next.
          </p>
        </div>
      </div>

      {/* Slanted video */}
      <div className="mt-12 pl-8 lg:pl-44" style={{ perspective: '1200px' }}>
        <div
          style={{
            transform: 'rotateX(20deg) skewX(12deg)',
            transformOrigin: 'top left',
            maskImage:
              'linear-gradient(to bottom, black 55%, transparent 100%), linear-gradient(to right, black 75%, transparent 100%)',
            WebkitMaskImage:
              'linear-gradient(to bottom, black 55%, transparent 100%), linear-gradient(to right, black 75%, transparent 100%)',
            maskComposite: 'intersect',
            WebkitMaskComposite: 'source-in',
          }}
          className="pl-6 pt-6"
        >
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            src="/previews/support-resistance.mov"
            autoPlay
            muted
            loop
            playsInline
            className="w-full border border-white/10 object-cover shadow-2xl"
          />
        </div>
      </div>
    </section>
  )
}
